module.exports = __webpack_public_path__ + "img/badge-infinity.3f9a504f.png";